import Heading from "./ui";

const { FaUsersLine } = require("react-icons/fa6");
const { MdLibraryBooks, MdAutoGraph } = require("react-icons/md");

export const ReportsSection = ({
  numOfUsers,
  numOfGroups,
  numOfcampaigns,
  groupleader,
}) => {
  return (
    <div className="w-full bg-transparent  mt-1 !pt-0 !pl-0 p-8 mb-8">
      <Heading text="Overview" />
      <div className="flex flex-wrap justify-between items-center gap-8">
        <ReportCard title="Users" value={numOfUsers} icon={<FaUsersLine />} />
        {groupleader && (
          <ReportCard
            title="Active Campaigns"
            value={numOfGroups}
            icon={<MdLibraryBooks />}
          />
        )}
        {!groupleader && (
          <ReportCard
            title="Groups"
            value={numOfGroups}
            icon={<MdLibraryBooks />}
          />
        )}
        {groupleader && (
          <ReportCard
            title="Training Modules"
            value={numOfcampaigns}
            icon={<MdAutoGraph />}
          />
        )}
        {!groupleader && (
          <ReportCard
            title="Campaigns"
            value={numOfcampaigns}
            icon={<MdAutoGraph />}
          />
        )}
      </div>
    </div>
  );
};

export const ReportCard = ({ title, value, icon }) => {
  return (
    <div className="flex-1 min-w-[200px] bg-gray-50 rounded-lg p-6 shadow-md transition-all duration-300 hover:shadow-xl">
      <div className="flex items-center justify-between mb-4">
        <span className="text-4xl text-[#23436d]">{icon}</span>
        <span className="text-3xl font-bold text-[#23436d]">{value}</span>
      </div>
      <h3 className="text-xl text-gray-700">{title}</h3>
    </div>
  );
};
